module.exports = __webpack_public_path__ + "img/caijiqi04.a8f5f267.png";